import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext';

const TenantContext = createContext();

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within TenantProvider');
  }
  return context;
};

export const TenantProvider = ({ children }) => {
  const { isAuthenticated, loading: authLoading } = useAuth();
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Only fetch organization if user is authenticated
    if (isAuthenticated && !authLoading) {
      fetchOrganization();
    } else if (!authLoading && !isAuthenticated) {
      // User is not authenticated, stop loading
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, authLoading]);

  const fetchOrganization = async () => {
    try {
      const response = await api.get('/organizations/me');
      setOrganization(response.data.organization);
    } catch (error) {
      console.error('Failed to fetch organization:', error);
      setOrganization(null);
    } finally {
      setLoading(false);
    }
  };

  const updateOrganization = async (updates) => {
    try {
      const response = await api.put('/organizations/me', updates);
      setOrganization(response.data.organization);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Update failed'
      };
    }
  };

  const value = {
    organization,
    loading: loading || authLoading,
    updateOrganization,
    refreshOrganization: fetchOrganization
  };

  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
};
